export const phone = (field: any, value: string): boolean => {
    const regex = /^(\+[0-9])?[\s\-]?\(?[0-9][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2,3}$/
    if (regex.test(value) && value.length < 255) {
        return true;
    } else {
        return false;
    }
}
export const email = (field: any, value: string): boolean => {
    console.log('check email', value)
    if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || !value?.length){
        return true;
    } else{
        return false;
    }
}
export const fio = (field: any, value: string) => {
    const regExp = /^([А-ЯЁA-Z]|[А-ЯЁA-Z][\x27а-яёa-z]{1,}|[А-ЯЁA-Z][\x27а-яёa-z]{1,}\-([А-ЯЁA-Z][\x27а-яёa-z]{1,}|(оглы)|(кызы)))\040[А-ЯЁA-Z][\x27а-яёa-z]{1,}(\040[А-ЯЁA-Z][\x27а-яёa-z]{1,})?$/
    return regExp.test(value)
}
export const maxDigits = (max: number) => {
    return (field: any, value: string) => {
      if (value.length <= max) {
        return true;
      } else {
        return false;
      }
    };
};
export const checkSpaces = (field: any, value: string) => {
    return value && value.trim() === '' ? false : true
};
  